import {types} from 'mobx-state-tree';

const Role = types.model('Role', {
  description: types.identifier,
  role: types.string,
  isPremierUser: types.maybeNull(types.boolean) //FPSE-3168 Allow null
})

export default Role;
